module.exports = __webpack_public_path__ + "files/58aca149e44d2ce515df0f8d3c7b3643.svg";